export default __webpack_public_path__ + "assets/json/af4fdb604f9ad72e3110691775be4c39.json";